import React from "react";
import styled from "styled-components";
import { theme } from "../theme";

const PricesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  color: ${theme.colors.primary};
  min-height: 100vh;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const Title = styled.h1`
  font-size: 2.5em;
  margin-bottom: 20px;
  color: ${theme.colors.primary};
  text-align: center;
`;

const Subtitle = styled.h2`
  font-size: 1.8em;
  margin-top: 30px;
  color: ${theme.colors.primary};
  text-align: center;
`;

const Table = styled.table`
  width: 80%;
  max-width: 800px;
  border-collapse: collapse;
  margin: 20px 0;
  color: ${theme.colors.primary};

  @media (max-width: 768px) {
    font-size: 0.9em;
  }
`;

const TableHead = styled.thead`
  background-color: ${theme.colors.primary};
  color: black;
`;

const TableHeader = styled.th`
  padding: 15px;
  font-size: 1.2em;
  border: 1px solid ${theme.colors.primary};
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: rgba(218, 165, 32, 0.2);
  }
`;

const TableData = styled.td`
  padding: 15px;
  text-align: center;
  border: 1px solid ${theme.colors.primary};
  font-size: 1.1em;
`;

const Prices: React.FC = () => {
  return (
    <PricesContainer>
      <Title>Prijs en lesinformatie</Title>

      <Table>
        <TableHead>
          <tr>
            <TableHeader colSpan={2}>Lessen</TableHeader>
          </tr>
        </TableHead>
        <tbody>
          <TableRow>
            <TableData>Rijles (Schakel)</TableData>
            <TableData>€50,00</TableData>
          </TableRow>
         
          <TableRow>
            <TableData>Proefles</TableData>
            <TableData>€50,00</TableData>
          </TableRow>
          <TableRow>
            <TableData>Rijles (Automaat)</TableData>
            <TableData>€53,00</TableData>
          </TableRow>
        
          <TableRow>
            <TableData>Intake</TableData>
            <TableData>€79,00</TableData> 
          </TableRow>
        </tbody>
      </Table>

      <Table>
        <TableHead>
          <tr>
            <TableHeader colSpan={2}>Examens en toetsen</TableHeader>
          </tr>
        </TableHead>
        <tbody>
          <TableRow>
            <TableData>Praktijk examen</TableData>
            <TableData>€300,00</TableData>
          </TableRow>
         
          <TableRow>
            <TableData>Tussentijdse toets</TableData>
            <TableData>€300,00</TableData>
          </TableRow>
          <TableRow>
            <TableData>BNOR examen</TableData>
            <TableData>€327,00</TableData>
          </TableRow>
          <TableRow>
            <TableData>Faalangst examen</TableData>
            <TableData>€381,00</TableData>
          </TableRow>
        </tbody>
      </Table>

      <Subtitle>Pakketten</Subtitle>

      <Table>
        <TableHead>
          <tr>
            <TableHeader colSpan={2}>Pakket A</TableHeader>
          </tr>
        </TableHead>
        <tbody>
          <TableRow>
            <TableData colSpan={2}>Intake</TableData> {/* Centered text for Intake */}
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>15 x Rijlessen</TableData> {/* Centered text for Rijles */}
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>Praktijk examen</TableData> {/* Centered text for Praktijkexamen */}
          </TableRow>
          <TableRow>
            <TableData>Prijs</TableData>
            <TableData>€1099,00</TableData>
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>Gespreid betalen mogelijk</TableData>
          </TableRow>
        </tbody>
      </Table>

      <Table>
        <TableHead>
          <tr>
            <TableHeader colSpan={2}>Pakket B</TableHeader>
          </tr>
        </TableHead>
        <tbody>
          <TableRow>
            <TableData colSpan={2}>Intake</TableData> {/* Centered text for Intake */}
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>20 x Rijlessen</TableData> {/* Centered text for Rijles */}
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>Praktijk examen</TableData> {/* Centered text for Praktijkexamen */}
          </TableRow>
          <TableRow>
            <TableData>Prijs</TableData>
            <TableData>€1339,00</TableData>
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>Gespreid betalen mogelijk</TableData>
          </TableRow>
        </tbody>
      </Table>

      <Table>
        <TableHead>
          <tr>
            <TableHeader colSpan={2}>Pakket C</TableHeader>
          </tr>
        </TableHead>
        <tbody>
          <TableRow>
            <TableData colSpan={2}>Intake</TableData> {/* Centered text for Intake */}
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>30 x Rijlessen</TableData> {/* Centered text for Rijles */}
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>Praktijk examen</TableData> {/* Centered text for Praktijkexamen */}
          </TableRow>
          <TableRow>
            <TableData>Prijs</TableData>
            <TableData>€1819,00</TableData>
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>Gespreid betalen mogelijk</TableData>
          </TableRow>
        </tbody>
      </Table>
    </PricesContainer>
  );
};

export default Prices;
